package com.eladfinish.bible.contest.extensions

inline fun <T> T.runIf(condition: Boolean, block: T.() -> T): T = if (condition) block() else this

inline fun <T> T.runIfNot(condition: Boolean, block: T.() -> T): T = if (condition.not()) block() else this
